/**
 * useCreatePayrollRun — mutation új bérszámfejtési futtatás draft létrehozásához
 */

import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createDraft, type CreatePayrollRunInput, type PayrollRunDto } from '../api/payroll-api';

export function useCreatePayrollRun() {
  const queryClient = useQueryClient();

  return useMutation<PayrollRunDto, Error, CreatePayrollRunInput>({
    mutationFn: async (input: CreatePayrollRunInput) => {
      const res = await createDraft(input);
      return res.data;
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['payroll', 'runs'] });
    },
  });
}
